import CircleCheck from '@/assets/icons/circle-check.svg?react';
import Button from '@/components/ui/button/button.component';
import { cn } from '@/lib/utils';
import { cva, VariantProps } from 'class-variance-authority';

const stepIconVariants = cva(cn(''), {
  variants: {
    variant: {
      default:
        '[&>div]:bg-light-gray [&>div>.progress]:bg-topbar-bg [&>div>.index>div]:bg-primary [&>div>.index>p]:text-primary [&>div>.index>div>.svg]:text-primary',
      disabled:
        '[&>div]:bg-light-gray [&>div>.progress]:bg-topbar-bg-disabled [&>div>.index>div]:bg-secondary-text [&>div>.index>p]:text-secondary-text [&>div>.index>div>.svg]:text-primary',
      completed:
        '[&>div]:bg-light-gray [&>div>.progress]:bg-topbar-bg-disabled [&>div>.index>div]:bg-secondary-text [&>div>.index>p]:text-secondary-text [&>div>.index>div>.svg]:text-secondary-text',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
});

export type StepIconTopbarVariantProps = VariantProps<typeof stepIconVariants>;

interface StepIconTopbarProps extends React.ButtonHTMLAttributes<HTMLButtonElement>, StepIconTopbarVariantProps {
  index: number;
  text: React.ReactNode;
  progress: number;
  onClick?: () => void;
}

export const StepIconTopbar = ({
  index,
  text,
  progress,
  variant,
  onClick: handleClick,
  ...props
}: StepIconTopbarProps) => {
  return (
    <Button
      onClick={handleClick}
      variant="topbar"
      className={cn(
        stepIconVariants({
          variant,
        }),
      )}
      {...props}
    >
      <div className="flex flex-row items-center rounded-[50px] relative">
        <div
          className="progress absolute h-full rounded-tl-[50px] rounded-bl-[50px]"
          style={{
            width: `${progress}%`,
            borderStartEndRadius: progress === 100 ? '50px' : '0',
            borderEndEndRadius: progress === 100 ? '50px' : '0',
          }}
        />
        <div className="index flex flex-row items-center gap-x-3 p-2">
          <div className="w-6 h-6 rounded-full flex justify-center items-center text-white-text">
            {progress === 100 && <CircleCheck className="svg rounded-[50px]" />}
            {progress !== 100 && <p className="typo-label">{index}</p>}
          </div>
          <p className="typo-primary-500 group-hover:underline">{text}</p>
        </div>
      </div>
    </Button>
  );
};
